import { DateTime } from 'luxon'
import { makeAutoObservable, runInAction } from 'mobx'
import Receipt from 'src/models/Receipt'
import apiClient from 'src/utils/apiClient'

///////////////////////////////////
// Types
///////////////////////////////////

const CACHE_SIZE = 10

type GetReceiptParams = {
  userId: number
  date: DateTime
}

///////////////////////////////////
// Store
///////////////////////////////////

export default class ReceiptStore {
  private caches = new Map<string, Receipt>()

  receipt: Receipt | null = null
  receiptDates: DateTime[] = []

  constructor() {
    makeAutoObservable(this)
  }

  setReceipt = (receipt: Receipt | null) => {
    this.receipt = receipt
  }

  getReceipt = async ({ userId, date }: GetReceiptParams) => {
    const cacheKey = this.cacheKey(date)
    const cache = this.caches.get(cacheKey)
    if (cache) return this.setReceipt(cache)

    const receiptData = await apiClient.receipts.getReceipt({
      userId,
      year: date.year,
      month: date.month,
    })

    const receipt = new Receipt(receiptData)

    this.caches.set(cacheKey, receipt)

    // キャッシュサイズを超えた場合、最も古いキャッシュを削除
    if (this.caches.size > CACHE_SIZE) this.caches.delete(this.caches.keys().next().value)

    this.setReceipt(receipt)
  }

  getReceiptDates = async (userId: number) => {
    const dates = await apiClient.receipts.getReceiptDates({ userId })

    runInAction(() => {
      this.receiptDates = dates.map((date) => DateTime.fromISO(date))
    })
  }

  // Private actions ---------------

  private cacheKey = (date: DateTime) => {
    return date.toFormat('yyyy-MM')
  }
}
